const videos = document.querySelectorAll('.video--overlay');

function stopAllVideos() {
  // eslint-disable-next-line no-shadow
  const videos = document.querySelectorAll('video');
  videos.forEach((video) => {
    video.pause();
  });
}

if (videos.length > 0) {
  videos.forEach((videoContainer) => {
    const button = videoContainer.querySelector('.video__overlay-play');
    const overlay = videoContainer.querySelector('.video__overlay');
    const video = videoContainer.querySelector('video');

    button.addEventListener('click', () => {
      stopAllVideos();
      overlay.remove();
      video.play();
      video.setAttribute('tabindex', '1');
    });
  });
}
